import Vue from "vue";
import App from "./App.vue";
import store from "./store/main";
import router from "./router";
import "@/plugins/register-service-worker.js";
import "@/plugins/axios";
import VueLazyload from 'vue-lazyload'

import * as constants from "@/mixins/constants";
import * as trackingEvents from "@/mixins/event-tracking";

import VueGtag from "vue-gtag";

Vue.config.productionTip = false;
Vue.prototype.$constants = constants;
import i18n from "@/mixins/i18n";

import Buefy from "buefy";
Vue.use(Buefy);
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_KEY }
});

Vue.use(VueLazyload)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

import moment from "moment";
moment.locale(store.state.locale);
Vue.prototype.$moment = moment;



import "cropperjs/dist/cropper.css";

Vue.prototype.$getCookie = cname => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

Vue.prototype.$setCookie = (key, value, exdays = 3) => {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

  let expires = "expires=" + d.toUTCString();
  document.cookie = `${key}=${value};${expires};path=/`;
};

Vue.prototype.$deleteCookie = (sKey, sPath, sDomain) => {
  document.cookie = encodeURIComponent(sKey) +
  "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
  (sDomain ? "; domain=" + sDomain : "") +
  (sPath ? "; path=" + sPath : "");
},
Vue.prototype.$baseUrl = window.location.origin
Vue.prototype.$gtag = window.gtag
Vue.prototype.$trackingEvents = trackingEvents


const getTokenInURL = () => {
  // Not support IE, ref: https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
  const url = new URL(window.location.href)
  return url.searchParams.get("token")
}

const token = getTokenInURL() || Vue.prototype.$getCookie(constants.COOKIE_SUPPLIER_TOKEN)
if (token) {
  Vue.prototype.$setCookie(constants.COOKIE_SUPPLIER_TOKEN, token)
  store.dispatch("setSupplierToken", token)
}

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
